<template>
	<div class="password-wrap" style="position: relative;">

		<el-input
			v-if="type =='el-input'"
			ref="passwordInput"
			v-model="password"
			:placeholder="placeholder"
			type="password"
			:width="width"
			show-password
			:disabled="disabled"
			@input="handleFocus"
			@blur="handleBlur"
		/>
		<input-item
			v-else
			ref="passwordInput"
			v-model="password"
			:placeholder="placeholder"
			type="password"
			:width="width"
			show-password
			:disabled="disabled"
			@input="handleFocus"
			@blur="handleBlur"
		/>
		<div v-show="showRules" class="password-rules" :style="type === 'el-input' ? 'top: 88px;' : 'top: 48px;'">
			<p class="rules-title">{{ $t('login.passwordValidator.title') }}</p>

			<div v-for="rule in rules" :key="rule.ruleId" class="rule-item">
				<i :class="getRuleIconClass(rule.ruleId)" />
				<span>{{ rule.checkMessage }}</span>
			</div>

		</div>

	</div>
</template>

<script>
import { getPasswordRules, validatePassword } from '@monsters/behavior-verification-cloyster/libs/password'
import { initPassword } from '@/api/geeAxios'
export default {
	name: 'PasswordValidator',
	props: {
		value: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		width: {
			type: String,
			default: '100%'
		},
		type: {
			type: String,
			default: 'el-input'
		},
		disabled: {
			type: Boolean,
			default: false
		}

	},
	data() {
		return {
			showRules: false,
			password: this.value,
			ruleStatus: {}, // 密码规则验证结果
			rules: [] // 密码规则列表

		}
	},

	watch: {
		password(val) {
			this.$emit('input', val)

			const result = validatePassword(val, { mode: 'PARALLEL' }, this.rules)
			this.ruleStatus = result
			this.$emit('validation', {
				valid: this.ruleStatus.status === 'PASSED',
				message: this.getFirstFailedRuleMessage(result)
			})
		},
		value(val) {
			this.password = val
		}

	},
	created() {
		initPassword()
		this.fetchRules()
	},
	methods: {
		async fetchRules() {
			// NOTE:日语不支持 按照英文规则展示
			const lang = localStorage.getItem('lang') === 'zh' ? 'cn' : 'en'
			try {
				const rules = await getPasswordRules({ language: lang, scene: 'Password' })
				this.rules = rules
			} catch (error) {
				console.error('获取密码规则失败:', error)
			}
		},
		getFirstFailedRuleMessage(data) {
			// 检查status是否为FAILED
			if (data.status !== 'FAILED') {
				return ''
			}

			const firstFailedItem = data.list.find(item => item.validateStatus === 'FAILED')

			return firstFailedItem ? firstFailedItem.rule.checkMessage : ''
		},

		// 获取规则图标的class
		getRuleIconClass(ruleId) {
			if (!this.password) {
				// 未开始验证时显示默认圆圈
				return 'el-icon-circle default'
			}
			const rule = this.ruleStatus.list.find(r => r.rule.ruleId === ruleId)
			const isValid = rule.validateStatus === 'PASSED'
			if (isValid) {
				return 'el-icon-success valid'
			} else {
				return 'el-icon-circle invalid'
			}
		},

		handleFocus(event) {
			this.showRules = true
		},

		handleBlur() {
			this.showRules = false
		}

	}
}
</script>

<style scoped>
.password-rules {
	background: #FFFFFF;
	box-shadow: 0 0 8px 0 rgba(46, 67, 105, 0.16);
	border-radius: 8px;
	width: 320px;
	padding: 16px;
	position: absolute;
	z-index: 100;
	top: 48px;
}

.rules-title {
	margin: 0 0 12px 0;
	font-family: PingFangSC-Semibold;
	font-size: 14px;
	color: rgba(46, 67, 105, 0.85);
	letter-spacing: 0;
	font-weight: 600;
}

.rule-item {
	display: flex;
	align-items: baseline;
	margin-bottom: 6px;
	font-family: PingFangSC-Regular;
	font-size: 14px;
	color: rgba(46, 67, 105, 0.85);
	letter-spacing: 0;
	font-weight: 400;
	line-height: 20px;
}

.rule-item:last-child {
	margin-bottom: 0;
}

.rule-item i {
	margin-right: 8px;
	font-size: 14px;
	flex-shrink: 0;
}

.el-icon-circle{
	display: inline-block;
	width: 12px;
	height: 12px;
	border-radius: 100%;
	border: 1px solid currentColor;
}
.valid {
	color: #67c23a;
}

.invalid {
	color: #f56c6c;
}

.default {
	color: #ddd;
}

/* Element UI 样式覆盖 */
.el-input__inner {
	border-radius: 4px;
}

.el-button {
	border-radius: 4px;
}
</style>
